import React from "react";
import "./index.css";

export default function FundYourAccount() {
  return (
    <div className="fund-acc-container">
      {/* Heading Section */}
      <div className="fund-acc-header">
        <h1 className="fund-acc-title">FUND YOUR ACCOUNT</h1>
      </div>

      {/* Instructions Section */}
      <div className="fund-acc-content">
        <h2 className="fund-acc-subtitle">
          Deposit Instructions for Trading Account
        </h2>
        <p className="fund-acc-description">
          Ensure the security and compliance of your trading account by
          following these guidelines for making deposits:
        </p>

        <div className="fund-acc-list">
          <div className="fund-acc-item">
            <span className="fund-acc-number">1.</span>
            <p className="fund-acc-text">
              <strong>Crossed Cheque:</strong> Only a crossed cheque issued by
              you (the account holder) and payable to the Company will be
              accepted.
            </p>
          </div>

          <div className="fund-acc-item">
            <span className="fund-acc-number">2.</span>
            <p className="fund-acc-text">
              <strong>Pay Order:</strong> A pay order from your personal bank
              account, made in favor of the Company, is acceptable.
            </p>
          </div>

          <div className="fund-acc-item">
            <span className="fund-acc-number">3.</span>
            <p className="fund-acc-text">
              <strong>Other Banking Instruments:</strong> Any other banking
              instruments (e.g., demand drafts) must also originate from your
              own bank account and be made in favor of the Company.
            </p>
          </div>

          <div className="fund-acc-item">
            <span className="fund-acc-number">4.</span>
            <p className="fund-acc-text">
              <strong>Online Transfers:</strong> You may also transfer funds
              online directly from your personal digital banking account to the
              Company’s designated bank account.
            </p>
          </div>
        </div>

        <div className="fund-acc-warning">
          <p>
            <strong>Important Note:</strong> Cash transactions exceeding{" "}
            <span>PKR 25,000/-</span> are strictly prohibited and will not be
            accepted under any circumstances.
          </p>
        </div>

        <div className="fund-acc-footer">
          <p className="fund-acc-thank-you">
            Thank you for your cooperation in adhering to these deposit
            guidelines.
          </p>
          <a href="/bank-details" className="fund-acc-link">
            Click here for detailed account information for deposits.
          </a>
        </div>
      </div>
    </div>
  );
}
